import { Component, OnInit, Inject, HostListener, OnDestroy  } from '@angular/core';
import { FormControl } from '@angular/forms';
import {GoogleChartInterface } from 'ng2-google-charts/ng2-google-charts';
import { BQRequestService } from'../service/bqrequest.service';
import { MarkersService } from '../service/markers.service';
import { MarkerInterface } from '../models/marker';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as moment from 'moment';
import { MatSnackBar } from '@angular/material/snack-bar';


//Aqui se arma la estructura de datos pasada al dialogo con grafico
export interface DialogData {
  name: string;
  chartdata: any;
  value: string;
}

const Doptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
const months = ["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"]

@Component({
  selector: 'app-comparatives',
  templateUrl: './comparatives.component.html',
  styleUrls: ['./comparatives.component.css']
})
export class ComparativesComponent implements OnInit, OnDestroy {

  constructor(private requestService: BQRequestService,
    private markersService: MarkersService,
    public dialog: MatDialog,
    private snackBar: MatSnackBar) { }

    private subMarkers: any;
    markers: MarkerInterface[];
    public sites: any[] = [];
    public query: any[] = [];
    public dailyQuery: any[] = [];

    public originalQuery: any[] = [];

    public myNewDims; //Adaptive size
    public loadingData = true;

    public maxDate = new Date()
    dummy = new Date();
    public minDate = new Date(this.dummy.setFullYear(this.dummy.getFullYear() - 1)); //one year back

    //para el selector de mes
    public today = new Date();
    public sixMonthsAgo = new Date();
    public MonthdateControl = new FormControl();
    public MonthdateControl2 = new FormControl();

    public tree;
    public TopSelector = new FormControl();
    public TopLvlSelected = '';
    public topLevel;
    public MidSelector = new FormControl();
    public MidLvlSelected = '';
    public midLevel;
    public LastSelector = new FormControl();
    public LastLvlSelected = '';
    public lastLevel;
    public date1 = new FormControl();
    public date2 = new FormControl();
    public sub;
    public sub2;
    public Months: any[] = [];
    public NewGChart: GoogleChartInterface = {
      chartType: 'ColumnChart',
      dataTable: [['ts', ' ', { role: 'annotation' }, ' ', { role: 'annotation' }, ' ', { role: 'annotation' }],
      ['',          0, 0, 0, 0, 0, 0]],

      options:{
        legend: {position: 'top', textStyle:{fontSize: 10}},
        chartArea: { left: 80, right: 60, top: 30, bottom: 50},
        animation: {duration: 900, easing: 'inAndOut'},
        hAxis: {
          textStyle:{fontSize: 10}
          // format:'MMMM',
          // gridlines: {
          //   units: {
          //     months: {format: ['MMMM']},
          //   }
          // },
          // ticks: [new Date('2020-01-12'), new Date('2020-02-12'), new Date('2020-03-12')]
        },
        vAxis: {
          title: 'kW-h',
          visible: 'true',
          position: 'in',
          viewWindow: {min:0},
          textStyle:{fontSize: 10}
        },
        annotations: {
          highContrast: true,
          textStyle: {
            color: '#000000',
            fontSize: 12
          }
        },
        //colors: ['#3366CC', '#DC3912', '#FF9900'],
        // seriesType: 'bars',
        // series: {4: {type: 'line'}},
        height: 500
      }
    };

    public DailyChart: GoogleChartInterface = {
      chartType: 'LineChart',
      dataTable: [['ts', ' ', { role: 'annotation' }, ' ', { role: 'annotation' }, ' ', { role: 'annotation' }],
      ['',          0, 0, 0, 0, 0, 0]],

      options:{
        legend: {position: 'top', textStyle:{fontSize: 10}},
        chartArea: { left: 70, right: 60, top: 30, bottom: 60},
        animation: {duration: 900, easing: 'inAndOut'},
        hAxis: {
          textStyle:{fontSize: 10}
          // format:'MMMM',
          // gridlines: {
          //   units: {
          //     months: {format: ['MMMM']},
          //   }
          // },
          // ticks: [new Date('2020-01-12'), new Date('2020-02-12'), new Date('2020-03-12')]
        },
        vAxis: {
          title: 'kW-h',
          visible: 'true',
          position: 'in',
          viewWindow: {min:0},
          textStyle:{fontSize: 10}
        },
        annotations: {
          highContrast: true,
          textStyle: {
            color: '#000000',
            fontSize: 12
          }
        },
        interpolateNulls: true,
        //colors: ['#424242', '#DC3912', '#FF9900'],
        // seriesType: 'bars',
        // series: {4: {type: 'line'}},
        height: 500
      }
    };

  ngOnInit() {
    this.loadingData = true;
    this.sixMonthsAgo.setMonth(this.today.getMonth() - 12);
    let dummy = this.today;
    dummy.setDate(1);
    
    this.MonthdateControl.setValue(dummy);
    this.MonthdateControl2.setValue(new Date());
    this.MonthdateControl2.updateValueAndValidity();
    //retrieves the markers to place in tree
    this.subMarkers = this.markersService.getMarkers().subscribe(marker =>{
      this.markers = marker;
      let sitespreproc = [];
      for (let index = 0; index < this.markers.length; index++){
        this.sites.push({'bd_id': this.markers[index].zone + '-' + this.markers[index].city + '-' + this.markers[index].office, 'index': index})
        sitespreproc.push({'zone': this.markers[index].zone, 'city': this.markers[index].city, 'site': this.markers[index].office, 'bd_id': this.markers[index].zone + '-' + this.markers[index].city + '-' + this.markers[index].office})
      }
      this.createTree();
      this.topLevel = Object.keys(this.tree);
      this.midLevel = [];
      this.lastLevel = [];
      //con esto relleno el selector del centro con las ciudades
      for (let tops in this.topLevel){
        let dummy = Object.keys(this.tree[this.topLevel[tops]])
        for(let inds in dummy)
        {
          this.midLevel.push(dummy[inds]);
        }
      }
      //con esto relleno el selector final con los sitios
      for (let tops in this.topLevel){
        let dummy = Object.keys(this.tree[this.topLevel[tops]])
        for(let inds in dummy)
        {
          let dummy2 = Object.keys(this.tree[this.topLevel[tops]][dummy[inds]])
          for(let last in dummy2)
          {
            this.lastLevel.push({name: dummy2[last], id: this.topLevel[tops] + '/' + dummy[inds] + '/' + dummy2[last]})

          }
        }
      }

      // this.Loadingsites = Promise.resolve(true); //para actualizar el contenido de lo cargado desde BD
      //ahora con los sitios puedo pedir los datos de diarios.
      //Aqui se toman los valores diarios
      this.sub2 = this.requestService.sendDailyRequestYear(moment(dummy).format('YYYY-MM-DD'), moment(new Date()).format('YYYY-MM-DD')).subscribe(result =>{
        this.dailyQuery = [];
        let dailyChart = [];

        for(let row in result){
          this.dailyQuery.push({"id": [ result[row][0], result[row][1], result[row][2] ].join('-'), "kwh": result[row][3], "Fecha": result[row][7]})
        }

        let newTable = new google.visualization.DataTable();
        newTable.addColumn("string", "Fecha");
        let rowDefinition = [];
        let rowBuffer = ['fecha'];
        let header = ['Fecha'];
        let finalDataTable = [];
        
        for(let site in this.sites){
          newTable.addColumn("number", this.sites[site]['bd_id'])
          rowDefinition.push({"name": this.sites[site]['bd_id'], "id": site});
          rowBuffer.push(this.sites[site]['bd_id']);
          header.push(this.sites[site]['bd_id']);
        }
        //finalDataTable.push(header);
        //console.log(finalDataTable);

        //aqui proceso lo que viene de BDD para mostrar grafica
        
        //loop por los resultados
        let dateUsed = [];
        for(let data in this.dailyQuery)
        {
          //anotamos fecha siempre viene en sort desde BD
          let date = this.dailyQuery[data]['Fecha'];
          let s = dateUsed.includes(date);
          //limpio buffer
          let buffer = [];
          for(let res in buffer){buffer[res] = null}
          buffer[0] = date;      
          if(!s) //si es fecha nueva se anota
          {
            //buscamos el lugar y la posicion donde anotar en grafica linea1 linea2 etc.
            for(let sl in this.dailyQuery)
            {
              if(this.dailyQuery[sl]['Fecha'] == date)
              {
                for(let place in rowDefinition)
                {
                  let id = rowDefinition[place].name;
                  //se agrega la columna inicial
                  if(this.dailyQuery[sl]['id'] == id)
                  {
                    buffer[parseInt(rowDefinition[place].id) + 1 ] = this.dailyQuery[sl]['kwh'];
                  }
                }
              }
            } 
            finalDataTable.push(buffer);
            dateUsed.push(date);
          }           
        }
        newTable.addRows(finalDataTable);

        // for (let site in this.dailyQuery){
        //   //aqui preparo la fila
        //   newTable.addRow([this.dailyQuery[site]['Fecha'], this.dailyQuery[site]['kwh'], 0, 0])
        // }
        // console.log(newTable);
        this.DailyChart.dataTable = newTable;
        
        let cComponent = this.DailyChart.component;
        let wrapper = cComponent.wrapper;
        cComponent.draw();

        console.log('Query Daily Year done');
        this.sub2.unsubscribe();
      })


      // Aqui tomamos los valores de BDD
      this.sub = this.requestService.sendIndexesRequest().subscribe(result =>{
        //console.log('query done')
        this.query = [];
        let newChart = [];
        if(result[0] != undefined){      
          ////////////////////////////////////////////////Se agrego para mostrar meses////////////////////////////////////////////////////////////////////////////////////////////
          let firstM = result[0][10];
          let YearInit = result[0][10].split('-')[0];
          let YearInitCopy = YearInit;
          let firstMCopy = result[0][10].split('-')[1];

          firstM = firstM.split('-');
          firstM = parseInt(firstM[1]) - 1;
          let yearone = true;
          //Esto Rellena un año completo con datos desde Query
          for(let x=firstM; x <  firstM+12; x++){

            if(x>11){
              if(yearone){
              YearInit = parseInt(YearInit) + 1
              YearInit = String(YearInit);
              yearone = false;
              }
              this.Months.push(months[x-12]+"-"+YearInit.slice(-2));

            }
            else{
              this.Months.push(months[x]+"-"+YearInit);
            }
          }
          ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          for (let parts in result)
          {
            var site = result[parts][0] + '/'+ result[parts][1] + '/' + result[parts][2];
            var kwh = Number(result[parts][3].toFixed(1));
            var usd = Number((result[parts][3] * 0.09).toFixed(1));
            this.query.push({"id": site, "kwh": kwh, "usd": usd, "Fecha": result[parts][10]})
            this.originalQuery.push({"id": site, "kwh": kwh, "usd": usd, "Fecha": result[parts][10]})
          }
          
          let table = new google.visualization.DataTable();
          table.addColumn("string", "Sitio");
          this.query.sort(this.dynamicSortAlt('id'));
          this.query.forEach(function (a) {
            if (!this[a.Fecha]) {
                this[a.Fecha] = { id: a.id ,kwh: 0, usd: 0, Fecha: a.Fecha};
                newChart.push(this[a.Fecha]);
                let dummy = a.Fecha.split('-');
                let year = dummy[0];
                let month = dummy[1];
                month = months[parseInt(month) - 1];
                let fechaStr = [month, year].join('-');
                table.addColumn("number", fechaStr);
                table.addColumn({type: 'string', role: 'tooltip'});
            }
          }, Object.create(null));
          newChart.sort(this.dynamicSort('Fecha'));

          for(let site in this.sites){
            let row = [this.sites[site]['bd_id']]
            if(this.sites[site]['bd_id'] == 'Sierra-Quito-Inaquito')
            {
              row = ['Sierra-Quito-Iñaquito'];
            }            
            for(let consu in this.query){
              let id = this.query[consu].id;
              id = id.replaceAll('/', '-');
              if(id == this.sites[site]['bd_id']){
                row.push(this.query[consu].kwh);
                row.push("kWh: "+this.query[consu].kwh+"\nUSD: "+this.query[consu].usd);
              }
              // else
              // {
              //   row.push(0);
              //   row.push("kWh: -\nUSD: -");
              // }
            }
            //console.log(row);
            table.addRow(row);
          }

          // let table = new google.visualization.DataTable();
          // table.addColumn("string", "Sitio");
          // table.addColumn("number", "Total kWh");
          // table.addColumn({type: "string", role: "tooltip"});
          // newChart.forEach(function (a){
          //   table.addRow([a.id, a.kwh, "kWh: "+a.kwh+"\nUSD: "+a.usd])
          // })

          // table.sort({column: 1, desc: true});

          this.date2.setValue(new Date());
          this.date1.setValue(new Date(new Date().getFullYear(), 0, 1));
          this.NewGChart.dataTable = table;
          let Ccomponent = this.NewGChart.component;
          let wrapper = Ccomponent.wrapper;
          Ccomponent.draw();
        }
        else
        {console.log('no hay datos para mostrar')}
        this.loadingData = false;

      });

      //this.loadingData = false;

    })    

    this.delay(80).then(any =>{
      document.getElementById('ac').className = 'nav-options mat-button selected';
    })
    
  }

  openDatePicker(dp) {
    dp.open();
  }

  closeDatePicker1(eventData: any, dp?:any) {
    // get month and year from eventData and close datepicker, thus not allowing user to select date
    let date = new Date(eventData);
    let year = date.getFullYear().toString();
    let month = (date.getMonth() + 1).toString();
    month = month.length > 1 ? month : '0' + month;
    let fulldate = [year, month, 1].join('-');
    this.MonthdateControl.setValue(new Date(fulldate));
    this.MonthdateControl.updateValueAndValidity();
    dp.close();
  }

  closeDatePicker2(eventData: any, dp?:any) {
    // get month and year from eventData and close datepicker, thus not allowing user to select date
    let date = new Date(eventData);
    let year = date.getFullYear().toString();
    let month = (date.getMonth() + 1).toString();
    month = month.length > 1 ? month : '0' + month;
    let lastDayOfMonth = new Date(date.getFullYear(), date.getMonth()+1, 0);
    let fulldate = [year, month, 1].join('-');
    this.MonthdateControl2.setValue( lastDayOfMonth );
    this.MonthdateControl2.updateValueAndValidity();
    dp.close();
  }

  closeDatePickerStart(eventData: any, dp?:any){
    let date = new Date(eventData);
    let year = date.getFullYear().toString();
    let month = (date.getMonth() + 1).toString();
    month = month.length > 1 ? month : '0' + month;
    let fulldate = [year, month, 1].join('-');
    this.date1.setValue(new Date(fulldate));
    this.date1.updateValueAndValidity();
    dp.close();
    this.chageDateFilter(null);
  }

  closeDatePickerEnd(eventData: any, dp?: any){
    let date = new Date(eventData);
    let year = date.getFullYear().toString();
    let month = (date.getMonth() + 1).toString();
    month = month.length > 1 ? month : '0' + month;
    let lastDayOfMonth = new Date(date.getFullYear(), date.getMonth()+1, 0);
    let fulldate = [year, month, 1].join('-');
    this.date2.setValue( lastDayOfMonth );
    this.date2.updateValueAndValidity();
    dp.close();
    this.chageDateFilter(null);
  }

  searchBD(){
    if(this.MonthdateControl.value > this.MonthdateControl2.value){
      this.snackBar.open('Fecha Inicio no puede ser superior a Fin.', '', {duration: 3000});
    }
    else
    {  
      this.loadingData = true;
      let date1 = new Date(this.MonthdateControl.value);
      let month = (date1.getMonth() + 1).toString();
      month = month.length > 1 ? month : '0' + month;
      let start = [date1.getFullYear().toString(), month.toString(), '01'].join('-');
      //fecha fin arreglo
      let date2 = this.MonthdateControl2.value;
      let lastDayOfMonth = new Date(date2.getFullYear(), date2.getMonth()+1, 0);
      let end = [lastDayOfMonth.getFullYear().toString(), (lastDayOfMonth.getMonth()+1).toString(), lastDayOfMonth.getDate().toString()].join('-');
      console.log(end);
      
      //Aqui se toman los valores diarios
      this.sub2 = this.requestService.sendDailyRequestYear(start, end).subscribe(result =>{        
        this.dailyQuery = [];
        let dailyChart = [];

        for(let row in result){
          this.dailyQuery.push({"id": [ result[row][0], result[row][1], result[row][2] ].join('-'), "kwh": result[row][3], "Fecha": result[row][7]})
        }

        if(this.dailyQuery.length == 0)
        {
          let table = [['ts', ' ', { role: 'annotation' }, ' ', { role: 'annotation' }, ' ', { role: 'annotation' }],
          ['',          0, 0, 0, 0, 0, 0]];
          this.DailyChart.dataTable = table;
          this.snackBar.open('No Hay Datos!', '', {duration: 3000});
          let cComponent = this.DailyChart.component;
          let wrapper = cComponent.wrapper;
          cComponent.draw();
          
          this.sub2.unsubscribe();
        }
        else
        {  
          let newTable = new google.visualization.DataTable();
          newTable.addColumn("string", "Fecha");
          let rowDefinition = [];
          let rowBuffer = ['fecha'];
          let header = ['Fecha'];
          let finalDataTable = [];

          for(let site in this.sites){
            newTable.addColumn("number", this.sites[site]['bd_id'])
            rowDefinition.push({"name": this.sites[site]['bd_id'], "id": site});
            rowBuffer.push(this.sites[site]['bd_id']);
            header.push(this.sites[site]['bd_id']);
          }

          //aqui proceso lo que viene de BDD para mostrar grafica
          //loop por los resultados
          let dateUsed = [];
          for(let data in this.dailyQuery)
          {
            //anotamos fecha siempre viene en sort desde BD
            let date = this.dailyQuery[data]['Fecha'];
            let s = dateUsed.includes(date);
            //limpio buffer
            let buffer = [];
            for(let res in buffer){buffer[res] = null}
            buffer[0] = date;      
            if(!s) //si es fecha nueva se anota
            {
              //buscamos el lugar y la posicion donde anotar en grafica linea1 linea2 etc.
              for(let sl in this.dailyQuery)
              {
                if(this.dailyQuery[sl]['Fecha'] == date)
                {
                  for(let place in rowDefinition)
                  {
                    let id = rowDefinition[place].name;
                    //se agrega la columna inicial
                    if(this.dailyQuery[sl]['id'] == id)
                    {
                      buffer[parseInt(rowDefinition[place].id) + 1 ] = this.dailyQuery[sl]['kwh'];
                    }
                  }
                }
              } 
              finalDataTable.push(buffer);
              dateUsed.push(date);
            }           
          }
          newTable.addRows(finalDataTable);
          
          this.DailyChart.dataTable = newTable;
          let cComponent = this.DailyChart.component;
          let wrapper = cComponent.wrapper;
          cComponent.draw();

          this.loadingData = false;
          this.sub2.unsubscribe();
        }
      })
    }


  }

  //crea el arbol de sitios
  createTree(){
    //Para obtener divisiones del proyecto *arbol
    this.tree = {};
    for (let parts of this.sites)
    {
      var toplvl = parts.bd_id.split('-')[0];
      var medlvl = parts.bd_id.split('-')[1];
      var lowlvl = parts.bd_id.split('-')[2];
      this.addProps(this.tree, toplvl + "."+medlvl+"."+lowlvl, parts.bd_id);

    }

    var keys = Object.keys(this.tree);
  }

  //resize
  @HostListener('window:resize', ['$event'])
  sizeChange($event){
    this.myNewDims = window.innerHeight - 175;

    if(this.myNewDims >= 500){this.NewGChart.options.height = 500;}else{this.NewGChart.options.height = 500;}
    if(window.innerWidth <= 600 ){this.NewGChart.options.width = 500;}else{this.NewGChart.options.width = '100%';}

    let ccComponent = this.NewGChart.component;
    let ccwrapper = ccComponent.wrapper;
    ccComponent.draw();

    ccComponent = this.DailyChart.component;
    ccwrapper = ccComponent.wrapper;
    ccComponent.draw();

    // this.currentChart.options.vAxis.baseline = '55'
    // let ccComponent2 = this.currentChart.component;
    // let ccwrapper2 = ccComponent.wrapper;

    // //redraw
    // ccComponent2.draw();
  }

  //funcion para crear el arbol desde BD
  addProps(obj, arr, val) {

    if (typeof arr == 'string')
        arr = arr.split(".");

    obj[arr[0]] = obj[arr[0]] || {};

    var tmpObj = obj[arr[0]];

    if (arr.length > 1) {
        arr.shift();
        this.addProps(tmpObj, arr, val);
    }
    else
        obj[arr[0]] = val;

    return obj;

  }

  //para filtrar selectores
  filterSelectors(){
    this.delay(10).then(any =>{
      this.midLevel = [];
      this.lastLevel = [];
      if(this.TopSelector.value == ''){ //si no hay nada seleccionado usar todo
        this.topLevel = Object.keys(this.tree);
      }
      else  //sino filtra
      {
        this.topLevel = this.TopSelector.value;
      }

      //con esto relleno el selector del centro con las ciudades
      for (let tops in this.topLevel){
        let dummy = Object.keys(this.tree[this.topLevel[tops]])
        for(let inds in dummy)
        {
          this.midLevel.push(dummy[inds]);
        }
      }
      //con esto relleno el selector final con los sitios
      for (let tops in this.topLevel){
        let dummy = Object.keys(this.tree[this.topLevel[tops]])
        for(let inds in dummy)
        {
          let dummy2 = Object.keys(this.tree[this.topLevel[tops]][dummy[inds]])
          for(let last in dummy2)
          {
            this.lastLevel.push({name: dummy2[last], id: this.topLevel[tops] + '/' + dummy[inds] + '/' + dummy2[last]})
          }
        }
      }
      //Aqui se actualiza lo que se muestra en grafica
      let newChart = [];
      let table = new google.visualization.DataTable();
      table.addColumn("string", "Sitio");
      this.query.forEach(function (a) {
        if (!this[a.Fecha]) {
          this[a.Fecha] = { id: a.id ,kwh: 0, usd: 0, Fecha: a.Fecha};
          newChart.push(this[a.Fecha]);
          let dummy = a.Fecha.split('-');
          let year = dummy[0];
          let month = dummy[1];
          month = months[parseInt(month) - 1];
          let fechaStr = [month, year].join('-');
          table.addColumn("number", fechaStr);
          table.addColumn({type: 'string', role: 'tooltip'});

        }
      }, Object.create(null));
      newChart.sort(this.dynamicSort('Fecha'));

      for(let site in this.lastLevel){
        let row = [this.lastLevel[site]['id']]
        if(this.lastLevel[site]['id'] == 'Sierra/Quito/Inaquito' || this.lastLevel[site]['id'] == 'Sierra/Quito/Iñaquito')
          {
            row = ['Sierra/Quito/Iñaquito']
          }
        for(let consu in this.query){
          let id = this.query[consu].id;
          //id = id.replaceAll('/', '-');
          if(id == this.lastLevel[site]['id'])
          {
            row.push(this.query[consu].kwh);
            row.push("kWh: "+this.query[consu].kwh+"\nUSD: "+this.query[consu].usd)
          }
        }
        table.addRow(row);
      }

      this.NewGChart.dataTable = table;
      let Ccomponent = this.NewGChart.component;
      let wrapper = Ccomponent.wrapper;
      Ccomponent.draw();
    })
  }

  //para filtrar selector medio
  filterMidSelectors(){
    this.delay(10).then(any =>{
      this.lastLevel = [];
      if(this.MidSelector.value == ''){
        //con esto relleno el selector final con los sitios
        for (let tops in this.topLevel){
          let dummy = Object.keys(this.tree[this.topLevel[tops]])
          for(let inds in dummy)
          {
            let dummy2 = Object.keys(this.tree[this.topLevel[tops]][dummy[inds]])
            for(let last in dummy2)
            {
              this.lastLevel.push({name: dummy2[last], id: this.topLevel[tops] + '/' + dummy[inds] + '/' + dummy2[last]})
            }
          }
        }
      }
      else
      {
        //con esto relleno el selector final con los sitios
        for (let tops in this.topLevel){
          let dummy = Object.keys(this.tree[this.topLevel[tops]])
          for(let inds in dummy)
          {
            let dummy2 = Object.keys(this.tree[this.topLevel[tops]][dummy[inds]])
            for(let last in dummy2)
            {
              if(this.MidSelector.value.includes(dummy[inds]))
                {
                  this.lastLevel.push({name: dummy2[last], id: this.topLevel[tops] + '/' + dummy[inds] + '/' + dummy2[last]})
                }
            }
          }
        }
      }
      this.LastSelector.setValue(this.lastLevel);
      //Aqui se actualiza lo que se muestra en grafica
      // depende de LastSelector


    })
  }

  //para filtrar ultimo nivel
  filterLastSelector(){
    this.delay(20).then(any =>{
      //Aqui se actualiza lo que se muestra en grafica
      let newChart = [];
      let table = new google.visualization.DataTable();
      table.addColumn("string", "Sitio");
      this.query.forEach(function (a) {
        if (!this[a.Fecha]) {
          this[a.Fecha] = { id: a.id ,kwh: 0, usd: 0, Fecha: a.Fecha};
          newChart.push(this[a.Fecha]);
          let dummy = a.Fecha.split('-');
          let year = dummy[0];
          let month = dummy[1];
          month = months[parseInt(month) - 1];
          let fechaStr = [month, year].join('-');
          table.addColumn("number", fechaStr);
          table.addColumn({type: 'string', role: 'tooltip'});
        }
      }, Object.create(null));
      newChart.sort(this.dynamicSort('Fecha'));


      if(this.LastSelector.value == '')
      {
        for(let site in this.lastLevel){
          let row = [this.lastLevel[site]['id']]    
          if(this.lastLevel[site]['id'] == 'Sierra/Quito/Inaquito' || this.lastLevel[site]['id'] == 'Sierra/Quito/Iñaquito')
          {
            row = ['Sierra/Quito/Iñaquito']
          }          
          for(let consu in this.query){
            let id = this.query[consu].id;
            //id = id.replaceAll('/', '-');
            if(id == this.lastLevel[site]['id'])
            {
              row.push(this.query[consu].kwh);
              row.push("kWh: "+this.query[consu].kwh+"\nUSD: "+this.query[consu].usd)
            }
          }
          table.addRow(row);
        }
      }
      else
      {
        for(let site in this.LastSelector.value){
          let row = [this.LastSelector.value[site]['id']]          
          if(this.LastSelector.value[site]['id'] == 'Sierra/Quito/Inaquito' || this.LastSelector.value[site]['id'] == 'Sierra/Quito/Iñaquito')
          {
            row = ['Sierra/Quito/Iñaquito']
          }
          for(let consu in this.query){
            let id = this.query[consu].id;
            if(id == this.LastSelector.value[site]['id'])
            {
              row.push(this.query[consu].kwh);
              row.push("kWh: "+this.query[consu].kwh+"\nUSD: "+this.query[consu].usd)
            }
          }
          table.addRow(row);
        }
      }


      this.NewGChart.dataTable = table;
      let Ccomponent = this.NewGChart.component;
      let wrapper = Ccomponent.wrapper;
      Ccomponent.draw();


    })
  }

  //evento de grafica
  onSelect(event) {
    //Aqui se procesa para co2
    if((event.columnLabel == "Total Emisiones CO2" || event.column == 1) && event.selectedRowValues != '')
    {
      this.openWindow(event.selectedRowValues[0], 'Total Emisiones CO2', this.originalQuery);
      return;
    }
    else if((event.columnLabel == "Total Emisiones CO2" || event.column == 1) && event.selectedRowValues == '') //para ocultar/mostrar serie
    {
      this.toggleSeries(event, 'tonco2', this.NewGChart.dataTable.wg[0]);
      return;
    }

    //Aqui se procesa para kwh
    if((event.columnLabel == "Total kW⋅h/m²" || event.column == 2) && event.selectedRowValues != '')
    {
      this.openWindow(event.selectedRowValues[0], 'Total kW⋅h/m²', this.originalQuery);
      return;
    }
    else if((event.columnLabel == "Total kW⋅h/m²" || event.column == 2) && event.selectedRowValues == '') //para ocultar/mostrar serie
    {
      this.toggleSeries(event, 'kwh', this.NewGChart.dataTable.wg[0]);
      return;
    }

    //Aqui se procesa para Agua
    if((event.columnLabel == "Total m³/Usuario" || event.column == 3) && event.selectedRowValues != '')
    {
      this.openWindow(event.selectedRowValues[0], 'Total m³/Usuario', this.originalQuery);
    }
    else if((event.columnLabel == "Total m³/Usuario" || event.column == 3) && event.selectedRowValues == '') //para ocultar/mostrar serie
    {
      this.toggleSeries(event, 'water', this.NewGChart.dataTable.wg[0]);
    }
  }

  //evento al cambiar fecha
  chageDateFilter(event){
    let startDate = this.date1.value;
    let endDate = this.date2.value;

    this.query = this.originalQuery.filter(function(a){
      let aDate = new Date(a.Fecha);
      return aDate >= startDate && aDate <= endDate;
    });

    this.delay(10).then(any =>{
      //Aqui se actualiza lo que se muestra en grafica
      let newChart = [];
      let table = new google.visualization.DataTable();
      table.addColumn("string", "Sitio");

      this.query.forEach(function (a) {
        if (!this[a.Fecha]) {
          this[a.Fecha] = { id: a.id ,kwh: 0, usd: 0, Fecha: a.Fecha};
          newChart.push(this[a.Fecha]);
          let dummy = a.Fecha.split('-');
          let year = dummy[0];
          let month = dummy[1];
          month = months[parseInt(month) - 1];
          let fechaStr = [month, year].join('-');
          table.addColumn("number", fechaStr);
          table.addColumn({type: 'string', role: 'tooltip'});
        }
      }, Object.create(null));
      newChart.sort(this.dynamicSort('Fecha'));



      if(this.LastSelector.value == null || this.LastSelector.value == '')
      {
        for(let site in this.lastLevel){
          let row = [this.lastLevel[site]['id']]
          if(this.lastLevel[site]['id'] == 'Sierra-Quito-Inaquito')
          {
            row = ['Sierra-Quito-Iñaquito']
          }
          for(let consu in this.query){
            let id = this.query[consu].id;
            //id = id.replaceAll('/', '-');
            if(id == this.lastLevel[site]['id'])
            {
              row.push(this.query[consu].kwh);
              row.push("kWh: "+this.query[consu].kwh+"\nUSD: "+this.query[consu].usd)
            }
          }
          table.addRow(row);
        }
      }
      else
      {
        for(let site in this.LastSelector){
          let row = [this.LastSelector.value[site]['id']]
          if(this.LastSelector.value[site]['id'] == 'Sierra-Quito-Inaquito')
          {
            row = ['Sierra-Quito-Iñaquito']
          }
          for(let consu in this.query){
            let id = this.query[consu].id;
            //id = id.replaceAll('/', '-');
            if(id == this.LastSelector.value[site]['id'])
            {
              row.push(this.query[consu].kwh);
              row.push("kWh: "+this.query[consu].kwh+"\nUSD: "+this.query[consu].usd)
            }
          }
          table.addRow(row);
        }
      }


      this.NewGChart.dataTable = table;
      let Ccomponent = this.NewGChart.component;
      let wrapper = Ccomponent.wrapper;
      Ccomponent.draw();

    })
  }

  //evento al ocultar serie
  toggleSeries(event, serie, context){
    let startDate = this.date1.value;
    let endDate = this.date2.value;

    console.log(context, serie);
    this.query = this.originalQuery.filter(function(a){
      let aDate = new Date(a.Fecha);
      return aDate >= startDate && aDate <= endDate;
    });

    this.delay(10).then(any =>{
      //Aqui se actualiza lo que se muestra en grafica
      let newChart = [];
      let color1 = '#424242'
      let color2 = '#DC3912'
      let color3 = '#FF9900'
      //si se quiere ocultar emisiones
      if(serie == 'tonco2' && context.c[1].v != null)
        {
          this.query.forEach(function (a) {
            if (!this[a.id]) {
                this[a.id] = { id: a.id ,tonco2: 0, kwhm2: 0, m3usuario: 0, total: 0};
                newChart.push(this[a.id]);
            }
            // this[a.id].tonco2 += a.tonco2;
            // this[a.id].tonco2 = (Math.round((this[a.id].tonco2 + Number.EPSILON) * 100) / 100);
            this[a.id].tonco2 = null;
            color1 = '#FFFFFF';
            if(context.c[2].v == null){this[a.id].kwhm2 = null; color2 = '#FFFFFF';}
            else if(context.c[2].v != null){this[a.id].kwhm2 += a.kwhm2;this[a.id].kwhm2 = (Math.round((this[a.id].kwhm2 + Number.EPSILON) * 100) / 100); this[a.id].total += a.kwhm2;}
            if(context.c[3].v == null){this[a.id].m3usuario = null; color3 = '#FFFFFF';}
            else if(context.c[3].v != null){this[a.id].m3usuario += a.m3usuario;this[a.id].m3usuario = (Math.round((this[a.id].m3usuario + Number.EPSILON) * 100) / 100); this[a.id].total += a.m3usuario;}
            //this[a.id].total += a.tonco2 + a.kwhm2 + a.m3usuario;
            this[a.id].total = (Math.round((this[a.id].total + Number.EPSILON) * 100) / 100);
          }, Object.create(null));

          let table = new google.visualization.DataTable();
          table.addColumn("string", "Sitio");
          table.addColumn("number", "Total Emisiones CO2");
          table.addColumn("number", "Total kW⋅h/m²");
          table.addColumn("number", "Total m³/Usuario");
          table.addColumn({type:'number', role:'certainty'});

          if(this.LastSelector.value == null || this.LastSelector.value == '')
          {
            newChart.forEach(function (a, index){
              for(let i in this)
              {
                if(this[i].id == a.id)
                {
                  table.addRow([a.id, a.tonco2, a.kwhm2, a.m3usuario, a.total])
                }
              }
            }, this.lastLevel)
          }
          else
          {
            newChart.forEach(function (a, index){
              for(let i in this)
              {
                if(this[i].id == a.id)
                {
                  table.addRow([a.id, a.tonco2, a.kwhm2, a.m3usuario, a.total])
                }
              }
            }, this.LastSelector.value)
          }

          table.sort({column: 4, desc: true});
          this.NewGChart.options.colors = [color1, color2, color3];

          this.NewGChart.dataTable = table;
          let Ccomponent = this.NewGChart.component;
          let wrapper = Ccomponent.wrapper;
          Ccomponent.draw();
      }
      else if(serie == 'tonco2' && context.c[1].v == null)
      {
        this.query.forEach(function (a) {
          if (!this[a.id]) {
              this[a.id] = { id: a.id ,tonco2: 0, kwhm2: 0, m3usuario: 0, total: 0};
              newChart.push(this[a.id]);
          }
          this[a.id].tonco2 += a.tonco2;
          this[a.id].tonco2 = (Math.round((this[a.id].tonco2 + Number.EPSILON) * 100) / 100);
          this[a.id].total += a.tonco2
          if(context.c[2].v == null){this[a.id].kwhm2 = null;color2 = '#FFFFFF';}
          else if(context.c[2].v != null){this[a.id].kwhm2 += a.kwhm2;this[a.id].kwhm2 = (Math.round((this[a.id].kwhm2 + Number.EPSILON) * 100) / 100); this[a.id].total += a.kwhm2}
          if(context.c[3].v == null){this[a.id].m3usuario = null;color3 = '#FFFFFF';}
          else if(context.c[3].v != null){this[a.id].m3usuario += a.m3usuario;this[a.id].m3usuario = (Math.round((this[a.id].m3usuario + Number.EPSILON) * 100) / 100); this[a.id].total += a.m3usuario}
          //this[a.id].total += a.tonco2 + a.kwhm2 + a.m3usuario;
          this[a.id].total = (Math.round((this[a.id].total + Number.EPSILON) * 100) / 100);
        }, Object.create(null));

        let table = new google.visualization.DataTable();
        table.addColumn("string", "Sitio");
        table.addColumn("number", "Total Emisiones CO2");
        table.addColumn("number", "Total kW⋅h/m²");
        table.addColumn("number", "Total m³/Usuario");
        table.addColumn({type:'number', role:'certainty'});

        if(this.LastSelector.value == null || this.LastSelector.value == '')
        {
          newChart.forEach(function (a, index){
            for(let i in this)
            {
              if(this[i].id == a.id)
              {
                table.addRow([a.id, a.tonco2, a.kwhm2, a.m3usuario, a.total])
              }
            }
          }, this.lastLevel)
        }
        else
        {
          newChart.forEach(function (a, index){
            for(let i in this)
            {
              if(this[i].id == a.id)
              {
                table.addRow([a.id, a.tonco2, a.kwhm2, a.m3usuario, a.total])
              }
            }
          }, this.LastSelector.value)
        }

        table.sort({column: 4, desc: true});
        this.NewGChart.options.colors = [color1, color2, color3];

        this.NewGChart.dataTable = table;
        let Ccomponent = this.NewGChart.component;
        let wrapper = Ccomponent.wrapper;
        Ccomponent.draw();
      }
      //si se quiere ocultar kwh
      if(serie == 'kwh' && context.c[2].v != null)
      {
        this.query.forEach(function (a) {
          if (!this[a.id]) {
              this[a.id] = { id: a.id ,tonco2: 0, kwhm2: 0, m3usuario: 0, total: 0};
              newChart.push(this[a.id]);
          }
          if(context.c[1].v == null){this[a.id].tonco2 = null;color1 = '#FFFFFF';}
          else if(context.c[1].v != null){this[a.id].tonco2 += a.tonco2;this[a.id].tonco2 = (Math.round((this[a.id].tonco2 + Number.EPSILON) * 100) / 100); this[a.id].total += a.tonco2}
          // this[a.id].kwhm2 += a.kwhm2;
          // this[a.id].kwhm2 = (Math.round((this[a.id].kwhm2 + Number.EPSILON) * 100) / 100);
          this[a.id].kwhm2 = null;
          color2 = '#FFFFFF';
          if(context.c[3].v == null){this[a.id].m3usuario = null;color3 = '#FFFFFF';}
          else if(context.c[3].v != null){this[a.id].m3usuario += a.m3usuario;this[a.id].m3usuario = (Math.round((this[a.id].m3usuario + Number.EPSILON) * 100) / 100); this[a.id].total += a.m3usuario}
          //this[a.id].total += a.tonco2 + a.kwhm2 + a.m3usuario;
          this[a.id].total = (Math.round((this[a.id].total + Number.EPSILON) * 100) / 100);
        }, Object.create(null));

        let table = new google.visualization.DataTable();
        table.addColumn("string", "Sitio");
        table.addColumn("number", "Total Emisiones CO2");
        table.addColumn("number", "Total kW⋅h/m²");
        table.addColumn("number", "Total m³/Usuario");
        table.addColumn({type:'number', role:'certainty'});

        if(this.LastSelector.value == null || this.LastSelector.value == '')
        {
          newChart.forEach(function (a, index){
            for(let i in this)
            {
              if(this[i].id == a.id)
              {
                table.addRow([a.id, a.tonco2, a.kwhm2, a.m3usuario, a.total])
              }
            }
          }, this.lastLevel)
        }
        else
        {
          newChart.forEach(function (a, index){
            for(let i in this)
            {
              if(this[i].id == a.id)
              {
                table.addRow([a.id, a.tonco2, a.kwhm2, a.m3usuario, a.total])
              }
            }
          }, this.LastSelector.value)
        }

        table.sort({column: 4, desc: true});
        this.NewGChart.options.colors = [color1, color2, color3];

        this.NewGChart.dataTable = table;
        let Ccomponent = this.NewGChart.component;
        let wrapper = Ccomponent.wrapper;
        Ccomponent.draw();
      }
      else if(serie == 'kwh' && context.c[2].v == null)
      {
        this.query.forEach(function (a) {
          if (!this[a.id]) {
              this[a.id] = { id: a.id ,tonco2: 0, kwhm2: 0, m3usuario: 0, total: 0};
              newChart.push(this[a.id]);
          }
          if(context.c[1].v == null){this[a.id].tonco2 = null;color1 = '#FFFFFF';}
          else if(context.c[1].v != null){this[a.id].tonco2 += a.tonco2;this[a.id].tonco2 = (Math.round((this[a.id].tonco2 + Number.EPSILON) * 100) / 100);this[a.id].total += a.tonco2}
          this[a.id].kwhm2 += a.kwhm2;
          this[a.id].kwhm2 = (Math.round((this[a.id].kwhm2 + Number.EPSILON) * 100) / 100);
          this[a.id].total += a.kwhm2
          if(context.c[3].v == null){this[a.id].m3usuario = null;color3 = '#FFFFFF';}
          else if(context.c[3].v != null){this[a.id].m3usuario += a.m3usuario;this[a.id].m3usuario = (Math.round((this[a.id].m3usuario + Number.EPSILON) * 100) / 100); this[a.id].total += a.m3usuario}
          //this[a.id].total += a.tonco2 + a.kwhm2 + a.m3usuario;
          this[a.id].total = (Math.round((this[a.id].total + Number.EPSILON) * 100) / 100);
        }, Object.create(null));

        let table = new google.visualization.DataTable();
        table.addColumn("string", "Sitio");
        table.addColumn("number", "Total Emisiones CO2");
        table.addColumn("number", "Total kW⋅h/m²");
        table.addColumn("number", "Total m³/Usuario");
        table.addColumn({type:'number', role:'certainty'});

        if(this.LastSelector.value == null || this.LastSelector.value == '')
        {
          newChart.forEach(function (a, index){
            for(let i in this)
            {
              if(this[i].id == a.id)
              {
                table.addRow([a.id, a.tonco2, a.kwhm2, a.m3usuario, a.total])
              }
            }
          }, this.lastLevel)
        }
        else
        {
          newChart.forEach(function (a, index){
            for(let i in this)
            {
              if(this[i].id == a.id)
              {
                table.addRow([a.id, a.tonco2, a.kwhm2, a.m3usuario, a.total])
              }
            }
          }, this.LastSelector.value)
        }

        table.sort({column: 4, desc: true});
        this.NewGChart.options.colors = [color1, color2, color3];

        this.NewGChart.dataTable = table;
        let Ccomponent = this.NewGChart.component;
        let wrapper = Ccomponent.wrapper;
        Ccomponent.draw();
      }
      //si se quiere ocultar agua
      if(serie == 'water' && context.c[3].v != null)
      {
        this.query.forEach(function (a) {
          if (!this[a.id]) {
              this[a.id] = { id: a.id ,tonco2: 0, kwhm2: 0, m3usuario: 0, total: 0};
              newChart.push(this[a.id]);
          }
          if(context.c[1].v == null){this[a.id].tonco2 = null;color1 = '#FFFFFF';}
          else if(context.c[1].v != null){this[a.id].tonco2 += a.tonco2;this[a.id].tonco2 = (Math.round((this[a.id].tonco2 + Number.EPSILON) * 100) / 100);this[a.id].total += a.tonco2}
          if(context.c[2].v == null){this[a.id].kwhm2 = null;color2 = '#FFFFFF';}
          else if(context.c[2].v != null){this[a.id].kwhm2 += a.kwhm2;this[a.id].kwhm2 = (Math.round((this[a.id].kwhm2 + Number.EPSILON) * 100) / 100);this[a.id].total += a.kwhm2}
          // this[a.id].m3usuario += a.m3usuario;
          // this[a.id].m3usuario = (Math.round((this[a.id].m3usuario + Number.EPSILON) * 100) / 100);
          this[a.id].m3usuario = null;
          color3 = '#FFFFFF';
          //this[a.id].total += a.tonco2 + a.kwhm2 + a.m3usuario;
          this[a.id].total = (Math.round((this[a.id].total + Number.EPSILON) * 100) / 100);
        }, Object.create(null));

        let table = new google.visualization.DataTable();
        table.addColumn("string", "Sitio");
        table.addColumn("number", "Total Emisiones CO2");
        table.addColumn("number", "Total kW⋅h/m²");
        table.addColumn("number", "Total m³/Usuario");
        table.addColumn({type:'number', role:'certainty'});

        if(this.LastSelector.value == null || this.LastSelector.value == '')
        {
          newChart.forEach(function (a, index){
            for(let i in this)
            {
              if(this[i].id == a.id)
              {
                table.addRow([a.id, a.tonco2, a.kwhm2, a.m3usuario, a.total])
              }
            }
          }, this.lastLevel)
        }
        else
        {
          newChart.forEach(function (a, index){
            for(let i in this)
            {
              if(this[i].id == a.id)
              {
                table.addRow([a.id, a.tonco2, a.kwhm2, a.m3usuario, a.total])
              }
            }
          }, this.LastSelector.value)
        }

        table.sort({column: 4, desc: true});
        this.NewGChart.options.colors = [color1, color2, color3];

        this.NewGChart.dataTable = table;
        let Ccomponent = this.NewGChart.component;
        let wrapper = Ccomponent.wrapper;
        Ccomponent.draw();
      }
      else if(serie == 'water' && context.c[3].v == null)
      {
        this.query.forEach(function (a) {
          if (!this[a.id]) {
              this[a.id] = { id: a.id ,tonco2: 0, kwhm2: 0, m3usuario: 0, total: 0};
              newChart.push(this[a.id]);
          }
          if(context.c[1].v == null){this[a.id].tonco2 = null;color1 = '#FFFFFF';}
          else if(context.c[1].v != null){this[a.id].tonco2 += a.tonco2;this[a.id].tonco2 = (Math.round((this[a.id].tonco2 + Number.EPSILON) * 100) / 100);this[a.id].total += a.tonco2}
          if(context.c[2].v == null){this[a.id].kwhm2 = null;color2 = '#FFFFFF';}
          else if(context.c[2].v != null){this[a.id].kwhm2 += a.kwhm2;this[a.id].kwhm2 = (Math.round((this[a.id].kwhm2 + Number.EPSILON) * 100) / 100);this[a.id].total += a.kwhm2}
          this[a.id].m3usuario += a.m3usuario;
          this[a.id].m3usuario = (Math.round((this[a.id].m3usuario + Number.EPSILON) * 100) / 100);
          this[a.id].total += a.m3usuario;
          this[a.id].total = (Math.round((this[a.id].total + Number.EPSILON) * 100) / 100);
        }, Object.create(null));

        let table = new google.visualization.DataTable();
        table.addColumn("string", "Sitio");
        table.addColumn("number", "Total Emisiones CO2");
        table.addColumn("number", "Total kW⋅h/m²");
        table.addColumn("number", "Total m³/Usuario");
        table.addColumn({type:'number', role:'certainty'});

        if(this.LastSelector.value == null || this.LastSelector.value == '')
        {
          newChart.forEach(function (a, index){
            for(let i in this)
            {
              if(this[i].id == a.id)
              {
                table.addRow([a.id, a.tonco2, a.kwhm2, a.m3usuario, a.total])
              }
            }
          }, this.lastLevel)
        }
        else
        {
          newChart.forEach(function (a, index){
            for(let i in this)
            {
              if(this[i].id == a.id)
              {
                table.addRow([a.id, a.tonco2, a.kwhm2, a.m3usuario, a.total])
              }
            }
          }, this.LastSelector.value)
        }

        table.sort({column: 4, desc: true});
        this.NewGChart.options.colors = [color1, color2, color3];

        this.NewGChart.dataTable = table;
        let Ccomponent = this.NewGChart.component;
        let wrapper = Ccomponent.wrapper;
        Ccomponent.draw();
      }
    })
  }

  //Para abrir la ventana emergente
  openWindow(name, telem, query){
    // const dialogRef = this.dialog.open(OverviewCharts, {
    //   data: {name: name, value: telem, chartdata: query, months: this.Months}
    // });
  }

  transformDate(date: string){
    let dummy = date.split('-');
    let year = dummy[0].substring(2);
    let month = dummy[1];
    month = this.Months[parseInt(month)];
    return([year, month].join('-'));
  }

  //sort menor mayor
  dynamicSort(property) {
  return function(a, b) {
      return (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
  }
  }

  //sort mayor menor
  dynamicSortAlt(property) {
    return function(a, b) {
        return (a[property] < b[property]) ? 1 : (a[property] > b[property]) ? -1 : 0;
    }
  }

  //delay
  async delay(ms: number) {
    await new Promise<void>(resolve => setTimeout(()=>resolve(), ms)).then(()=>console.log("delay ", ms));
  }

  //para dar formato a la fecha
  formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
  }

  //al salir limpia
  ngOnDestroy(){
    document.getElementById('ac').className = 'nav-options mat-button';
    this.subMarkers.unsubscribe();
    this.sub.unsubscribe();
    this.sizeChange = function() : void {};
    console.log('desuscrito de todo /Eficiency')

  }


}
